import React from "react";
import Header from "../Header";
import NavBar from "../navbar";
import Footer from "../Footer";
import Lower from "../Lower";

export default function ContactUs() {
  return (
    <>
      <Header />
      <NavBar />

      <div className="contact-wrapper">
        <h1 className="page-title">Contact Us</h1>

        <div className="contact-card">

  <h2 className="contact-main-title">Address</h2>

  <div className="contact-address">
    <div className="contact-section">
      <h2>ADROID CONNECTZ PVT LTD</h2>
      <p>
        2nd Floor, A-16, Sector-19,<br />
        Rohini, Delhi-110089,<br />
        INDIA
      </p>
    </div>

    <div className="contact-section">
      <h2>ADROID CONNECTZ UK LTD</h2>
      <p>
        71-75 Shelton Street,<br />
        Covent Garden, London,<br />
        United Kingdom, WC2H 9JQ
      </p>
    </div>
  </div>

  <div className="contact-divider" />


          <div className="contact-details-wrapper">
  <div className="contact-details">
    <p>
      <strong>Contact:</strong><br />
      +91-9899265660
    </p>

    <p>
      <strong>Email:</strong><br />
      <a href="mailto:adroidconnectz@gmail.com">
        adroidconnectz@gmail.com
      </a>
    </p>
  </div>
</div>

        </div>

        <style>{`
        .contact-main-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 30px;
}

          .contact-wrapper {
            padding: 40px 20px;
            max-width: 900px;
            margin: 0 auto;
            font-family: Arial, sans-serif;
          }

          .page-title {
            text-align: center;
            font-size: 32px;
            font-weight: 700;
            margin-bottom: 40px;
          }

          .contact-card {
            background: #ffffff;
            border-radius: 14px;
            padding: 32px;
            
            box-shadow: 0 6px 16px rgba(0,0,0,0.08);
          }
          .contact-address {
           display: flex;
            flex-direction: row;
            justify-content: space-around;
          }

          .contact-section {
            margin-bottom: 24px;
          }

          .contact-section h2 {
            font-size: 20px;
            margin-bottom: 8px;
          }

          .contact-section p {
            color: #555;
            line-height: 1.6;
          }

          .contact-divider {
            height: 1px;
            background: #e0e0e0;
            margin: 30px 0;
          }

          .contact-details p {
            margin-bottom: 16px;
            font-size: 16px;
          }

          .contact-details a {
            color: #2f80ed;
            text-decoration: none;
          }

          .contact-details a:hover {
            text-decoration: underline;
          }
          .contact-address {
  display: flex;
  justify-content: space-around;
  gap: 40px;
}

.contact-section {
  flex: 1;
  text-align: left;
}

.contact-details-wrapper {
  display: flex;
  justify-content: center;
}

.contact-details {
  text-align: center;
}

/* Mobile */
@media (max-width: 600px) {
  .contact-address {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .contact-section {
    text-align: center;
  }
}



          @media (max-width: 600px) {
          
            .page-title {
              font-size: 26px;
            }

            .contact-card {
              padding: 22px;
            }

            .contact-section h2 {
              font-size: 18px;
            }
          }
        `}</style>
      </div>

      <Lower />
      <Footer />
    </>
  );
}
